module.exports = __webpack_public_path__ + "static/media/group_6.9acdb4b1.png";